import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useProjectStore } from 'Store/Project'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import CustomActionCell from 'Presentation/Components/Table/Components/CustomActionCell'

const ViewModel = () => {
  const { id } = useParams<{ id: string }>()
  const { siteSupervisors, data, getOne, getSiteSupervisors, assignSiteSup, removeSitesup } =
    useProjectStore(state => ({
      siteSupervisors: state.availableSiteSupervisors,
      data: state.selected,
      getOne: state.getOne,
      getSiteSupervisors: state.getAvailableSiteSupervisors,
      assignSiteSup: state.assignSiteSupervisor,
      removeSitesup: state.unassignSiteSupervisor,
    }))

  const fetchData = () => {
    getSiteSupervisors()
  }

  const onAssignSiteSupervisor = async () => {
    Swal.fire({
      title: 'เพิ่มผู้ช่วย (Site Supervisor)',
      input: 'select',
      inputOptions: siteSupervisors.reduce((options, user) => {
        options[user.id] = user.fullName
        return options
      }, {} as Record<number, string>),
      inputPlaceholder: 'เลือกผู้ช่วย (Site Supervisor)',
      showCancelButton: true,
      inputValidator: value => {
        return new Promise(resolve => {
          if (value) {
            resolve('')
          } else {
            resolve('กรุณาเลือกผู้ช่วย (Site Supervisor)')
          }
        })
      },
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const formData = new FormData()
          formData.append('supervisorId', result.value)
          const { success, data } = await assignSiteSup(parseInt(id ?? ''), formData)
          if (success) {
            toast.success('เพิ่มผู้ช่วย (Site Supervisor) สำเร็จ')
            getOne(parseInt(id ?? ''))
          } else {
            toast.error(data?.message || data || 'เพิ่มผู้ช่วย (Site Supervisor) ไม่สำเร็จ')
          }
        } catch (error) {
          toast.error('เพิ่มผู้ช่วย (Site Supervisor) ไม่สำเร็จ')
        }
      }
    })
  }

  const onRemoveSiteSupervisor = async (userId: number) => {
    Swal.fire({
      title: 'คุณต้องการลบผู้ช่วย (Site Supervisor) ใช่หรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ยืนยัน',
      cancelButtonText: 'ยกเลิก',
    }).then(async result => {
      if (result.isConfirmed) {
        try {
          const formData = new FormData()
          formData.append('supervisorId', userId.toString())
          const { success, data } = await removeSitesup(parseInt(id ?? ''), formData)
          if (success) {
            toast.success('ลบผู้ช่วย (Site Supervisor) สำเร็จ')
            getOne(parseInt(id ?? ''))
          } else {
            toast.error(data?.message || data || 'ลบผู้ช่วย (Site Supervisor) ไม่สำเร็จ')
          }
        } catch (error) {
          toast.error('ลบผู้ช่วย (Site Supervisor) ไม่สำเร็จ')
        }
      }
    })
  }

  const columns: any[] = [
    {
      Header: 'ชื่อ-นามสกุล',
      accessor: 'supervisor',
      width: 200,
      minWidth: 200,
      disableSortBy: true,
      Cell: ({ value }: any) => <span className='text-gray-800'>{value?.fullName}</span>,
    },
    {
      Header: 'อีเมล',
      accessor: 'username',
      width: 200,
      minWidth: 200,
      Cell: ({ row }: any) => {
        return <span className='text-gray-800'>{row.original.supervisor.username ?? '-'}</span>
      },
    },
    {
      Header: 'ตำแหน่ง',
      accessor: 'roleTitle',
      width: 200,
      minWidth: 200,
      Cell: ({ row }: any) => {
        return <span className='text-gray-800'>{row.original.supervisor.roleTitle ?? '-'}</span>
      },
    },
    {
      Header: '',
      accessor: 'action',
      width: 100,
      minWidth: 100,
      Cell: ({ row }: any) => (
        <CustomActionCell
          id={row.original.supervisor.id}
          hideView
          hideEdit
          hideDuplicate
          onClickDelete={() => {
            onRemoveSiteSupervisor(row.original.supervisor.id)
          }}
        />
      ),
    },
  ]

  useEffect(() => {
    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { data: data?.siteSupervisors ?? [], siteSupervisors, columns, onAssignSiteSupervisor }
}

export default ViewModel
